import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import Cookies from "js-cookie";
import { useSession } from "@clerk/clerk-react";
import axios from "axios";
import { getUnexpiredToken } from "@/utils/utils";
import { useSupabaseStore } from "@/store/zustand/supabaseStore";

const FigmaCallbackPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const state = searchParams.get("state");
  const { session } = useSession();
  const supabaseClient = useSupabaseStore((state) => state.supabaseClient);
  const serverState = Cookies.get("state");

  useEffect(() => {
    if (!supabaseClient) return;

    if (state) {
      if (!state || state !== serverState) {
        setIsValid(false);
        console.error("Authentication failed: State mismatch");
      } else {
        session
          ?.getToken({ template: "figma" })
          .then(async (token) => {
            const clerkToken = await getUnexpiredToken(session);

            const response = await axios.post(
              `${import.meta.env.VITE_BACKEND_BASE_URL}/figma/auth/callback`,
              {
                token,
                write_key: state,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${clerkToken}`,
                },
              },
            );

            if (response.status === 200) {
              setIsValid(true);
            } else {
              setIsValid(false);
            }
          })
          .catch((error) => {
            console.error("Authentication failed: State mismatch");
            setIsValid(false);
          })
          .finally(() => {
            setSearchParams({});
          });
      }
    }
  }, [state, supabaseClient, serverState]);

  if (isValid === false) {
    return (
      <div className="min-h-screen w-screen bg-[#131519] flex items-center justify-center font-sans">
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="flex flex-row items-center justify-center gap-3">
            <div className="bg-[#1f1f22] rounded-lg p-3">
              <img src="/icons/tempo-logo-white.svg" className="w-6 h-6" />
            </div>
            <img src="/icons/divider.svg" className="w-8 h-8" />
            <div className="bg-[#1f1f22] rounded-lg p-3">
              <img src="/images/figma-logo.svg" className="w-6 h-6" />
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-4">
            <p className="text-white text-lg font-medium">
              Authentication failed. Please try again.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-screen bg-[#131519] flex items-center justify-center font-sans">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="flex flex-row items-center justify-center gap-3">
          <div className="bg-[#1f1f22] rounded-lg p-3">
            <img src="/icons/tempo-logo-white.svg" className="w-6 h-6" />
          </div>
          <img src="/icons/divider.svg" className="w-8 h-8" />
          <div className="bg-[#1f1f22] rounded-lg p-3">
            <img src="/images/figma-logo.svg" className="w-6 h-6" />
          </div>
        </div>
        <div className="flex flex-col items-center justify-center gap-2">
          <p className="text-white text-lg font-medium">
            You're signed in to Tempo
          </p>
          <p className="text-text-secondary text-xs font-medium">
            You can close this window and return to Figma.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FigmaCallbackPage;
